import {
  useCreateArticle,
  useCreateEvent,
  useCreateSnapshot,
  useDeleteContentItem,
  useUpdateArticle,
  useUpdateEvent,
  useUpdateSnapshot
} from '@lopo-tech/lopo-api'
import React from 'react'
import { useCreateAssetFlow } from 'src/utils/assets/createAsset'

export interface IContentItemMutations {
  createAsset: ReturnType<typeof useCreateAssetFlow>;
  createArticle: ReturnType<typeof useCreateArticle>[0];
  updateArticle: ReturnType<typeof useUpdateArticle>[0];
  createEvent: ReturnType<typeof useCreateEvent>[0];
  updateEvent: ReturnType<typeof useUpdateEvent>[0];
  createSnapshot: ReturnType<typeof useCreateSnapshot>[0];
  updateSnapshot: ReturnType<typeof useUpdateSnapshot>[0];
  deleteContentItem: ReturnType<typeof useDeleteContentItem>[0];
}

const useContentItemMutations = (): IContentItemMutations => {
  const [createArticle] = useCreateArticle()
  const [updateArticle] = useUpdateArticle()
  const [createEvent] = useCreateEvent()
  const [updateEvent] = useUpdateEvent()
  const [createSnapshot] = useCreateSnapshot()
  const [updateSnapshot] = useUpdateSnapshot()
  const [deleteContentItem] = useDeleteContentItem()
  const createAsset = useCreateAssetFlow()

  return {
    createAsset,
    createArticle,
    updateArticle,
    createEvent,
    updateEvent,
    createSnapshot,
    updateSnapshot,
    deleteContentItem
  }
}

export const withContentItemMutations = <T, >(
  Component:
    | React.ComponentClass<T & IContentItemMutations>
    | React.FC<T & IContentItemMutations>
): React.FC<T> => {
  const ComponentWithExtraProps: React.FC<T> = (props) => {
    const mutations = useContentItemMutations()

    return React.createElement(Component, { ...props, ...mutations })
  }

  return ComponentWithExtraProps
}
